// A `hidden`-type field: holds a value but is never user-editable. Renders an
// <input type="hidden"> so DOM-serializing hosts pick the value up; the value
// is also available via handle.getValue(). No label / shell. (Distinct from the
// `hidden` attribute on any field, which renders nothing at all.)

import type { FieldComponentProps } from '../rendererContext'
import { fieldIdFor } from '../ids'

export function HiddenField({ field, path, value }: FieldComponentProps) {
  void field
  return <input id={fieldIdFor(path)} type="hidden" value={value == null ? '' : String(value)} readOnly />
}
